// src/components/partner/InviteLearnerModal.jsx



import {

  useEffect,

  useMemo,

  useState,

} from "react";



import {

  AlertTriangle,

  CheckCircle2,

  Mail,

  Send,

  UserRound,

  X,

} from "lucide-react";



import {

  sendPartnerCohortInvite,

} from "../../lib/partner/partnerInvitations";



import {

  fetchPartnerCohortInvitationCapacity,

} from "../../lib/partner/partnerInvitationCapacity";









function formatUsage(

  usage,

  maximum

) {

  const used =

    Number(

      usage || 0

    );



  if (

    maximum === null ||

    maximum === undefined

  ) {

    return `${used} / Unlimited`;

  }



  return `${used} / ${Number(

    maximum

  )}`;

}





export default function InviteLearnerModal({

  open,

  cohorts = [],

  initialCohortId = "",

  lockCohort = false,

  onClose,

  onInvited,

}) {

  const [

    cohortId,

    setCohortId,

  ] = useState("");



  const [

    name,

    setName,

  ] = useState("");



  const [

    email,

    setEmail,

  ] = useState("");





  const [

    saving,

    setSaving,

  ] = useState(false);



  const [

    error,

    setError,

  ] = useState("");



  const [

    capacitySnapshot,

    setCapacitySnapshot,

  ] = useState(null);



  const [

    capacityLoading,

    setCapacityLoading,

  ] = useState(false);



  const [

    capacityError,

    setCapacityError,

  ] = useState("");





  /* ------------------------------------------------------------------------ */

  /* Available cohorts                                                        */

  /* ------------------------------------------------------------------------ */



  const availableCohorts =

    useMemo(

      () =>

        (

          Array.isArray(cohorts)

            ? cohorts

            : []

        ).filter(

          (cohort) =>

            cohort?.id &&

            cohort?.can_manage !==

              false &&

            cohort?.status ===

              "active"

        ),

      [cohorts]

    );





  const selectedCohort =

    useMemo(

      () =>

        availableCohorts.find(

          (cohort) =>

            String(

              cohort.id

            ) ===

            String(

              cohortId

            )

        ) || null,

      [

        availableCohorts,

        cohortId,

      ]

    );





  /* ------------------------------------------------------------------------ */

  /* Open/reset                                                               */

  /* ------------------------------------------------------------------------ */



  useEffect(() => {

    if (!open) {

      return;

    }



    const requestedCohort =

      availableCohorts.find(

        (cohort) =>

          String(

            cohort.id

          ) ===

          String(

            initialCohortId

          )

      );



    const nextCohortId =

      requestedCohort?.id ||

      availableCohorts[0]?.id ||

      "";



    setCohortId(

      nextCohortId

    );



    setName("");

    setEmail("");





    setSaving(false);

    setError("");

    setCapacitySnapshot(null);

    setCapacityError("");

  }, [

    open,

    initialCohortId,

    availableCohorts,

  ]);





  /* ------------------------------------------------------------------------ */

  /* Invitation capacity                                                      */

  /* ------------------------------------------------------------------------ */



  useEffect(() => {

    if (

      !open ||

      !selectedCohort?.id

    ) {

      setCapacitySnapshot(null);

      setCapacityError("");

      setCapacityLoading(false);



      return undefined;

    }



    let cancelled = false;



    async function loadCapacity() {

      try {

        setCapacityLoading(true);

        setCapacityError("");



        const snapshot =

          await fetchPartnerCohortInvitationCapacity(

            selectedCohort.id

          );



        if (cancelled) {

          return;

        }



        setCapacitySnapshot(

          snapshot

        );

      } catch (loadError) {

        console.error(

          "Invitation capacity loading failed:",

          loadError

        );



        if (cancelled) {

          return;

        }



        setCapacitySnapshot(null);



        setCapacityError(

          loadError?.message ||

            "Invitation availability could not be checked."

        );

      } finally {

        if (!cancelled) {

          setCapacityLoading(false);

        }

      }

    }



    loadCapacity();



    return () => {

      cancelled = true;

    };

  }, [

    open,

    selectedCohort?.id,

  ]);





  /* ------------------------------------------------------------------------ */

  /* Escape                                                                   */

  /* ------------------------------------------------------------------------ */



  useEffect(() => {

    if (!open) {

      return undefined;

    }



    function handleEscape(

      event

    ) {

      if (

        event.key ===

          "Escape" &&

        !saving

      ) {

        onClose?.();

      }

    }



    window.addEventListener(

      "keydown",

      handleEscape

    );



    return () => {

      window.removeEventListener(

        "keydown",

        handleEscape

      );

    };

  }, [

    open,

    saving,

    onClose,

  ]);





  if (!open) {

    return null;

  }





  const invitationBlocked =

    capacitySnapshot &&

    capacitySnapshot.can_invite !==

      true;



  const submitDisabled =

    saving ||

    !selectedCohort ||

    capacityLoading ||

    Boolean(capacityError) ||

    invitationBlocked;





  function handleBackdropClick(

    event

  ) {

    if (

      event.target ===

        event.currentTarget &&

      !saving

    ) {

      onClose?.();

    }

  }





  async function handleSubmit(

    event

  ) {

    event.preventDefault();



    try {

      setSaving(true);

      setError("");



      const cleanName =

        String(name || "")

          .trim();



      const cleanEmail =

        String(email || "")

          .trim()

          .toLowerCase();



      if (!selectedCohort) {

        throw new Error(

          "Please select a cohort."

        );

      }



      if (

        capacitySnapshot?.can_invite !==

          true

      ) {

        throw new Error(

          capacitySnapshot?.block_message ||

            capacityError ||

            "A new invitation cannot be sent to this cohort right now."

        );

      }



      if (!cleanName) {

        throw new Error(

          "Please enter the entrepreneur's name."

        );

      }



      if (

        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(

          cleanEmail

        )

      ) {

        throw new Error(

          "Please enter a valid entrepreneur email address."

        );

      }



      const result =

        await sendPartnerCohortInvite({

          cohortId:

            selectedCohort.id,



          name:

            cleanName,



          email:

            cleanEmail,



        });



      await onInvited?.({

        ...result,



        inviteeName:

          cleanName,



        email:

          result?.email ||

          cleanEmail,



        cohortId:

          result?.cohortId ||

          selectedCohort.id,



        cohortName:

          result?.cohortName ||

          selectedCohort.name,

      });



      onClose?.();

    } catch (

      submitError

    ) {

      console.error(

        "Sending entrepreneur invitation failed:",

        submitError

      );



      setError(

        submitError?.message ||

          "The invitation could not be sent."

      );

    } finally {

      setSaving(false);

    }

  }





  return (

    <div

      role="presentation"

      onMouseDown={

        handleBackdropClick

      }

      className="fixed inset-0 z-[120] flex items-end justify-center bg-black/45 p-0 sm:items-center sm:p-6"

    >

      <div

        role="dialog"

        aria-modal="true"

        aria-labelledby="invite-entrepreneur-title"

        className="max-h-[95vh] w-full overflow-y-auto rounded-t-[28px] bg-white shadow-2xl sm:max-w-xl sm:rounded-[28px]"

      >

        <header className="flex items-start justify-between border-b border-[#E7E7E7] px-6 py-5">

          <div>

            <p className="text-xs font-black uppercase tracking-[0.14em] text-[#FF914D]">

              Entrepreneur invitation

            </p>



            <h2

              id="invite-entrepreneur-title"

              className="mt-1 text-2xl font-black tracking-[-0.025em] text-[#333333]"

            >

              Invite an entrepreneur

            </h2>

          </div>



          <button

            type="button"

            onClick={

              onClose

            }

            disabled={

              saving

            }

            aria-label="Close entrepreneur invitation"

            className="flex h-10 w-10 items-center justify-center rounded-full text-[#757575] transition hover:bg-[#F3F3F3] hover:text-black disabled:opacity-50"

          >

            <X className="h-5 w-5" />

          </button>

        </header>



        <form

          onSubmit={

            handleSubmit

          }

          className="space-y-5 p-6"

        >

          <div className="rounded-2xl border border-[#FFD7BE] bg-[#FFF7F1] px-4 py-4">

            <p className="text-sm leading-relaxed text-[#76503B]">

              The entrepreneur will receive a secure email invitation to join this cohort on Gwin. The invitation link expires after seven days.

            </p>

          </div>



          {error && (

            <div

              role="alert"

              className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700"

            >

              {error}

            </div>

          )}



          <div>

            <label

              htmlFor={

                lockCohort

                  ? undefined

                  : "entrepreneur-invite-cohort"

              }

              className="block text-sm font-black text-[#333333]"

            >

              Cohort

            </label>



            {lockCohort ? (

              <div className="mt-2 rounded-2xl border border-[#DDDDDD] bg-[#F7F7F7] px-4 py-3">

                <p className="text-sm font-bold text-[#333333]">

                  {selectedCohort?.name ||

                    "Cohort unavailable"}

                </p>

              </div>

            ) : (

              <select

                id="entrepreneur-invite-cohort"

                value={

                  cohortId

                }

                onChange={(

                  event

                ) =>

                  setCohortId(

                    event.target.value

                  )

                }

                disabled={

                  saving

                }

                required

                className="mt-2 w-full rounded-2xl border border-[#DDDDDD] bg-white px-4 py-3 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15"

              >

                <option value="">

                  Select a cohort

                </option>



                {availableCohorts.map(

                  (cohort) => (

                    <option

                      key={

                        cohort.id

                      }

                      value={

                        cohort.id

                      }

                    >

                      {cohort.name}

                    </option>

                  )

                )}

              </select>

            )}

          </div>



          {selectedCohort && (

            <section className="rounded-2xl border border-[#E8E8E8] bg-[#FAFAFA] p-4">

              {capacityLoading ? (

                <p className="text-sm font-semibold text-[#757575]">

                  Checking learner allocation...

                </p>

              ) : capacityError ? (

                <div className="flex items-start gap-3">

                  <AlertTriangle className="mt-0.5 h-5 w-5 flex-none text-amber-700" />



                  <div>

                    <p className="text-sm font-black text-amber-900">

                      Invitation availability could not be checked

                    </p>



                    <p className="mt-1 text-xs leading-relaxed text-amber-800">

                      {capacityError}

                    </p>

                  </div>

                </div>

              ) : capacitySnapshot ? (

                <>

                  <div

  className={[

    "grid gap-3",

    capacitySnapshot.max_learners !== null &&

    capacitySnapshot.max_learners !== undefined

      ? "sm:grid-cols-2"

      : "",

  ].join(" ")}

>

  <div className="rounded-xl bg-white p-3">

    <p className="text-[11px] font-black uppercase tracking-wider text-[#757575]">

      Cohort capacity

    </p>



    <p className="mt-1 text-base font-black text-[#333333]">

      {formatUsage(

        capacitySnapshot.cohort_usage,

        capacitySnapshot.cohort_capacity

      )}

    </p>

  </div>



  {capacitySnapshot.max_learners !== null &&

    capacitySnapshot.max_learners !== undefined && (

      <div className="rounded-xl bg-white p-3">

        <p className="text-[11px] font-black uppercase tracking-wider text-[#757575]">

          Sponsored learner allocation

        </p>



        <p className="mt-1 text-base font-black text-[#333333]">

          {formatUsage(

            capacitySnapshot.learner_usage,

            capacitySnapshot.max_learners

          )}

        </p>

      </div>

    )}

</div>



                  {capacitySnapshot.can_invite ? (

                    <p className="mt-3 inline-flex items-center text-xs font-bold text-green-700">

                      <CheckCircle2 className="mr-1.5 h-4 w-4" />

                      A learner place is available.

                    </p>

                  ) : (

                    <div className="mt-3 flex items-start gap-2 text-amber-800">

                      <AlertTriangle className="mt-0.5 h-4 w-4 flex-none" />



                      <p className="text-xs font-semibold leading-relaxed">

                        {capacitySnapshot.block_message ||

                          "New learner invitations are currently unavailable."}

                      </p>

                    </div>

                  )}

                </>

              ) : null}

            </section>

          )}



          <div>

            <label

              htmlFor="entrepreneur-invite-name"

              className="block text-sm font-black text-[#333333]"

            >

              Entrepreneur name

            </label>



            <div className="relative mt-2">

              <UserRound className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#999999]" />



              <input

                id="entrepreneur-invite-name"

                type="text"

                value={

                  name

                }

                onChange={(

                  event

                ) =>

                  setName(

                    event.target.value

                  )

                }

                disabled={

                  saving ||

                  invitationBlocked

                }

                required

                maxLength={

                  120

                }

                autoComplete="name"

                placeholder="For example: Sarah Johnson"

                className="w-full rounded-2xl border border-[#DDDDDD] py-3 pl-11 pr-4 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15 disabled:bg-[#F7F7F7]"

              />

            </div>

          </div>



          <div>

            <label

              htmlFor="entrepreneur-invite-email"

              className="block text-sm font-black text-[#333333]"

            >

              Entrepreneur email address

            </label>



            <div className="relative mt-2">

              <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#999999]" />



              <input

                id="entrepreneur-invite-email"

                type="email"

                value={

                  email

                }

                onChange={(

                  event

                ) =>

                  setEmail(

                    event.target.value

                  )

                }

                disabled={

                  saving ||

                  invitationBlocked

                }

                required

                autoComplete="email"

                placeholder="entrepreneur@example.com"

                className="w-full rounded-2xl border border-[#DDDDDD] py-3 pl-11 pr-4 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15 disabled:bg-[#F7F7F7]"

              />

            </div>

          </div>



          <div className="flex flex-col-reverse gap-3 border-t border-[#EFEFEF] pt-5 sm:flex-row sm:justify-end">

            <button

              type="button"

              onClick={

                onClose

              }

              disabled={

                saving

              }

              className="rounded-full border border-[#D8D8D8] px-5 py-3 text-sm font-black text-[#555555] transition hover:bg-[#F5F5F5] disabled:opacity-50"

            >

              Cancel

            </button>



            <button

              type="submit"

              disabled={

                submitDisabled

              }

              className="inline-flex items-center justify-center rounded-full bg-[#FF914D] px-6 py-3 text-sm font-black text-white transition hover:bg-[#E9782F] disabled:cursor-not-allowed disabled:opacity-60"

            >

              <Send className="mr-2 h-4 w-4" />



              {saving

                ? "Sending invitation..."

                : "Send invitation"}

            </button>

          </div>

        </form>

      </div>

    </div>

  );

}